import { IonAlert, IonIcon, useIonRouter } from "@ionic/react";
import { ChannelSettings as SbChannelSettings, useSendbirdStateContext } from "@wearesweet/sendbird-uikit-react";
import ChannelProfile from "@wearesweet/sendbird-uikit-react/ChannelSettings/components/ChannelProfile";
import ModerationPanel from "@wearesweet/sendbird-uikit-react/ChannelSettings/components/ModerationPanel";
import { useChannelSettingsContext } from "@wearesweet/sendbird-uikit-react/ChannelSettings/context";
import { t } from "i18next";
import { logOutOutline } from "ionicons/icons";
import React, { useContext } from "react";
import { AuthenticatedUserContext } from "../../../contexts/AuthenticatedUserContext";
import { BlockMember } from "./BlockMember";
import { ChannelOfficial } from "./ChannelOfficial";
import { ChannelPinned } from "./ChannelPinned";

const CustomChannelProfile = (props: any) => {
  const { member } = useContext(AuthenticatedUserContext);
  const channelSettings = useChannelSettingsContext();

  return (
    <>
      <ChannelProfile />
      <div className={"sendbird-channel-settings__operator sendbird-channel-settings__operator--members-" + channelSettings.channel?.memberCount}>
        {member?.is_admin ? <ChannelOfficial /> : ""}
        {member?.is_admin ? <ChannelPinned /> : ""}
      </div>
    </>
  );
};

export const ChannelSettings = (props: any) => {
  const router = useIonRouter();
  const [leaveChannelAlertIsOpen, setLeaveChannelAlertIsOpen] = React.useState(false);
  const globalStore = useSendbirdStateContext();

  return (
    <SbChannelSettings
      channelUrl={props.channelUrl as string}
      renderChannelProfile={() => {
        return <CustomChannelProfile />;
      }}
      renderModerationPanel={() => {
        return (
          <>
            <ModerationPanel />
            <div className={"sendbird-channel-settings__operator"}>
              <BlockMember />
            </div>
          </>
        );
      }}
      onCloseClick={() => {
        if (props.onClose) {
          props.onClose();
        } else {
          router.goBack();
        }
      }}
      renderLeaveChannel={() => (
        <>
          <IonAlert
            isOpen={leaveChannelAlertIsOpen}
            onDidDismiss={() => {
              setLeaveChannelAlertIsOpen(false);
            }}
            header={t("leaveChannel") || ""}
            message={t("leaveChannelConfirmation") || ""}
            buttons={[
              {
                text: t("cancel"),
                role: "cancel",
                cssClass: "secondary",
              },
              {
                text: t("leave"),
                handler: () => {
                  setLeaveChannelAlertIsOpen(false);
                  globalStore.stores.sdkStore.sdk.groupChannel.getChannel(props.channelUrl).then((channel) => {
                    channel.leave().then(() => {
                      // wait a bit to make sure the channel is left
                      setTimeout(() => {
                        router.push("/chat");
                      }, 300);
                    });
                  });
                },
              },
            ]}
          />
          <div
            className="sendbird-channel-settings__panel-item sendbird-channel-settings__leave-channel "
            role="button"
            onClick={() => {
              setLeaveChannelAlertIsOpen(true);
            }}
          >
            <IonIcon icon={logOutOutline} color={"danger"} />
            <span className="sendbird-label sendbird-label--subtitle-1 sendbird-label--color-onbackground-1">{t("leaveChannel")}</span>
          </div>
        </>
      )}
      onLeaveChannel={() => {
        router.push("/chat");
      }}
    />
  );
};
